import { useDispatch } from 'react-redux';

export const useSystemNotificationsModal = () => {
    const dispatch = useDispatch();
    return {};
};
